import { BorderGridContainer, ContentTile, GridBox } from '@ahmdigital/ui';
import { filter, isEmpty, map } from 'lodash/fp';
import portableTextToPlain from '@ahmdigital/logic/lib/content/utils/portable-text-to-plain';
import React from 'react';

import { CONTENT_TYPE } from '../../../../../cms/constants';
import Award from '../../../../insurance/components/award';
import CommonQuestionsSection from '../../components/common-questions-section';
import ContentTilesSection from '../../../../../components/content-tiles-section';
import getContentTilesData from '../get-content-tiles-data';
import getImageAttributes from '../../../../../cms/utils/get-image-attributes';
import HowItWorks from '../../../../../components/how-it-works';
import Inclusions from '../../components/inclusions-section';
import PageSections from '../../../../consideration-landing/components/page-sections';
import ProductsSection from '../../../../../components/sections/products-section';
import QuickLinks from '../../../../../components/quick-links';
import Summaries from '../../components/summary-with-image-section';
import ValuePropositionsSection from '../../components/value-propositions';
import type {
  Section,
  SectionAwardType,
  SectionProductListingType,
  SectionSalesJourneyType,
} from '../../../../insurance/types';

const getContentToRender = (content: Section[]) =>
  map((section) => {
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property '__typename' does not exist on type 'Section'.
    const contentType = section?.__typename;
    if (contentType === CONTENT_TYPE.HOW_TO) {
      // @ts-expect-error - Automatic, Please fix when editing this file
      return <HowItWorks howTo={section} />;
    }
    if (contentType === CONTENT_TYPE.VALUE_PROPOSITIONS) {
      // @ts-expect-error - Automatic, Please fix when editing this file
      return <ValuePropositionsSection valuePropositions={section} />;
    }
    if (contentType === CONTENT_TYPE.COMMON_QUESTIONS) {
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'questions' does not exist on type 'Section'.
      const questions = section?.questions;
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'title' does not exist on type 'Section'.
      const questionsTitle = section?.title;
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'summary' does not exist on type 'Section'.
      const questionsSummary = section?.summary;
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'imageObject' does not exist on type 'Section'.
      const questionsImage = section?.imageObject;
      const image = getImageAttributes({ imageObject: questionsImage });
      const questionsToRender = questions ? (
        <CommonQuestionsSection image={image} questions={questions} title={questionsTitle} summary={questionsSummary} />
      ) : null;
      return questionsToRender;
    }
    if (contentType === CONTENT_TYPE.RELATED_TOPICS_URL) {
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'urlObjects' does not exist on type 'Section'.
      const relatedTopicsUrls = section?.urlObjects;
      return <QuickLinks isBrowserHandled title="Related topics" links={relatedTopicsUrls} type="quickLinks" />;
    }
    if (contentType === CONTENT_TYPE.SELLING_POINT) {
      // @ts-expect-error - Automatic, Please fix when editing this file
      return <Inclusions {...section} />;
    }

    if (contentType === CONTENT_TYPE.SALES_JOURNEY) {
      const { imageObject, descriptionRaw, name, urlObject } = section as SectionSalesJourneyType;
      const description = portableTextToPlain(descriptionRaw);

      const cta = urlObject
        ? [{ link: urlObject.url ?? '', linkText: urlObject.name ?? undefined, variant: ['flair'] }]
        : undefined;
      const image = getImageAttributes({ height: 240, imageObject });
      const formattedTile = {
        ctas: cta,
        image: !isEmpty(image) ? image : undefined,
        subtitle: description,
        title: name,
        urlObject,
      };

      return (
        <BorderGridContainer hideBorderTop>
          <GridBox padding="1rem">
            <ContentTile variant="fullWidth" {...formattedTile} />
          </GridBox>
        </BorderGridContainer>
      );
    }

    if (contentType === CONTENT_TYPE.TOPIC_GROUP) {
      // @ts-expect-error - Automatic, Please fix when editing this file
      return <Summaries {...section} />;
    }
    if (contentType === CONTENT_TYPE.AWARD) {
      const { imageObject, name, summaryRaw } = section as SectionAwardType;
      return <Award imageObject={imageObject} name={name} summaryRaw={summaryRaw} type="award" />;
    }
    if (contentType === CONTENT_TYPE.CONTENT_TILES) {
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'tiles' does not exist on type 'Section'.
      const tilesData = section?.tiles;
      const serviceTiles = filter((tileType) => tileType.type === 'service', tilesData);
      const explainedTermTiles = filter((tileType) => tileType.type === 'explainedTerm', tilesData);
      const contentTiles = getContentTilesData({ explainedTermTiles, serviceTiles });
      return <ContentTilesSection contentTiles={contentTiles} />;
    }

    if (contentType === CONTENT_TYPE.PRODUCT_LIST) {
      const { productIds, title, urlObject } = section as SectionProductListingType;
      const productListContent = {
        compareButtonText: urlObject?.name,
        compareButtonToLink: urlObject?.url,
        productIds,
        title,
        type: 'ProductListing',
        withBorder: true,
      };

      const sectionsContent = {
        sections: [productListContent],
      };

      return <PageSections components={{ ProductListing: ProductsSection }} content={sectionsContent} />;
    }
    return null;
  }, content);

export default getContentToRender;
